import {FormCheckboxType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const authorisationField: FormCheckboxType = {
	amount: null,
	id: 0,
	parent_id: 0,
	channel: 'checkbox',
	label:
		copy?.authorization ||
		'Ik heb toestemming om mijn teamleden in te schrijven',
	name: 'authorization',
	required: true
}

export default authorisationField
